module.exports = __webpack_public_path__ + "img/scholar.fb4529ea.jpg";